// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"156e03803edb06ba","5285":"490bdffa44a43c31"}[chunkId] + ".css";
};